import { render, staticRenderFns } from "./ArticleEmployees.vue?vue&type=template&id=21629be0&scoped=true&"
import script from "./ArticleEmployees.vue?vue&type=script&lang=js&"
export * from "./ArticleEmployees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21629be0",
  null
  
)

export default component.exports